import React from 'react';
import { ServicePageLayout } from './ServicePageLayout';
export function HotelWebsiteIreland() {
  const content = <div className="space-y-6 text-white/80" data-id="element-978">
      <p data-id="element-979">
        Ireland's tourism industry is world-renowned, but competition is fierce.
        Whether you run a boutique hotel in Dublin, a B&B in Wicklow, or a
        guesthouse in Galway, your website is your most important sales channel.
        Relying solely on Booking.com or Airbnb means paying high commissions on
        every stay.
      </p>

      <h2 className="text-2xl font-bold text-white mt-8 mb-4" data-id="element-980">
        Drive Direct Bookings
      </h2>
      <p data-id="element-981">
        The goal of your website should be to encourage direct bookings. We
        design sites that showcase your property's unique charm, highlight the
        benefits of booking direct (like better rates or free breakfast), and
        make the booking process seamless. Keep more of your revenue with a
        professional direct-booking website.
      </p>

      <h3 className="text-xl font-bold text-[#c9a84c] mt-6 mb-2" data-id="element-982">
        Features for Irish Hospitality
      </h3>
      <ul className="list-disc pl-6 space-y-2" data-id="element-983">
        <li data-id="element-984">
          <strong data-id="element-985">Stunning Galleries:</strong> High-quality images of your
          rooms, grounds, and local attractions.
        </li>
        <li data-id="element-986">
          <strong data-id="element-987">Local Guide:</strong> SEO-friendly content about things to do
          in your area to attract tourists.
        </li>
        <li data-id="element-988">
          <strong data-id="element-989">Direct Contact:</strong> WhatsApp or email links for
          personalized guest inquiries.
        </li>
        <li data-id="element-990">
          <strong data-id="element-991">Mobile Optimized:</strong> Perfect for travelers booking on
          the go.
        </li>
      </ul>

      <h2 className="text-2xl font-bold text-white mt-8 mb-4" data-id="element-992">
        Affordable Luxury
      </h2>
      <p data-id="element-993">
        You provide a premium experience for your guests; your website should
        reflect that. Our <strong data-id="element-994">€249 package</strong>
        gives you a luxury look for a budget price. It's the perfect solution
        for independent hotels and guesthouses looking to upgrade their online
        presence without the agency fees.
      </p>
    </div>;
  const faqs = [{
    q: 'Can I integrate a booking engine?',
    a: 'Yes, we can link to your existing booking engine (like Cloudbeds, SiteMinder, or simple forms) to handle reservations.'
  }, {
    q: 'Can I show local attractions?',
    a: "Absolutely. Creating a 'Things to Do' section is great for SEO and helpful for your guests."
  }, {
    q: 'Is the site mobile friendly?',
    a: 'Yes, fully responsive. Many travelers book on their phones, so we ensure the experience is smooth on all devices.'
  }, {
    q: 'How do I update room rates?',
    a: "If you use a booking engine, you'll update it there. For content on the site, you can use our AI editing tools to make quick text changes."
  }];
  const relatedServices = [{
    title: 'Restaurants',
    href: '/services/restaurant-website-dublin'
  }, {
    title: 'Barbers',
    href: '/services/barber-website-dublin'
  }, {
    title: 'Electricians',
    href: '/services/electrician-website-dublin'
  }, {
    title: 'Trades',
    href: '/services/trades-website-dublin'
  }];
  return <ServicePageLayout title="Hotel Website Design Ireland | Drive Direct Bookings" metaDescription="Beautiful websites for Irish hotels and B&Bs. Increase direct bookings and save on commissions. Professional design for just €249." heroTitle="Hotel Website Design Ireland" heroSubtitle="Showcase your property and drive commission-free direct bookings with a stunning hotel website." content={content} faqs={faqs} relatedServices={relatedServices} data-id="element-995" />;
}